import { useMutation } from '@apollo/client';
import {
    CreateGlobalTransactionEntryRuleDocument,
    CreateTransactionEntryRuleDocument,
    UpdateGlobalTransactionEntryRuleDocument,
    UpdateTransactionEntryRuleDocument,
} from '@common/graphql/generated';

export const useUpdateTransactionEntryRule = (isGlobalRule: boolean) =>
    useMutation(
        isGlobalRule
            ? UpdateGlobalTransactionEntryRuleDocument
            : UpdateTransactionEntryRuleDocument
    );

export const useCreateTransactionEntryRule = (isGlobalRule: boolean) =>
    useMutation(
        isGlobalRule
            ? CreateGlobalTransactionEntryRuleDocument
            : CreateTransactionEntryRuleDocument
    );
